<template>
  <div class="bor-cor new" :class="{ 'no-arrow': !arrow, 'is-tooltip': tooltip }">
    <div class="trigger" :class="{ display: display !== false, 'always-display': display }">
      <slot name="trigger"></slot>
    </div>
    <div
      v-if="!disabled && (display !== false)"
      class="menu-container"
      :class="[type, { reverse: reverse }]"
      :style="{
        'transform': 'translateX(' + translate + ')',
        '--sd-style': shadow,
        '--dvt-v': deviation.split(' ')[0],
        '--dvt-h': deviation.split(' ')[1],
        '--arw-w': arrowSize.split(' ')[0],
        '--arw-h': arrowSize.split(' ')[1],
        '--cbc-w': cursorSize.split(' ')[0],
        '--cbc-h': cursorSize.split(' ')[1],
        '--tt-v': (tooltip || {}).v || '5px',
        '--tt-h': (tooltip || {}).h || '5px'
      }"
      @mouseleave="e => $emit('leave')"
    >
      <div class="menu-block" :style="menuBlockStyle">
        <slot name="content"></slot>
      </div>
      <span v-if="!tooltip" class="cursor-bor-cor"></span>
      <template v-if="arrow && !tooltip">
        <span class="menu-bor-cor shadow-top" :style="{ '--bd-color': border }"></span>
        <span class="menu-bor-cor shadow-left" :style="{ '--bd-color': border }"></span>
        <span class="menu-bor-cor shadow-right" :style="{ '--bd-color': border }"></span>
        <span class="menu-bor-cor" :style="{ '--bg-color': background }"></span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: () => 'bottom'
    },
    reverse: {
      type: Boolean,
      default: () => false
    },
    arrow: {
      type: Boolean,
      default: () => true
    },
    tooltip: {
      type: Object,
      default: () => null
    },
    display: {
      type: Boolean,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    // style
    width: {
      type: String,
      default: () => ''
    },
    background: {
      type: String,
      default: () => 'white'
    },
    border: {
      type: String,
      default: () => '#aaaaaa'
    },
    radius: {
      type: String,
      default: () => '3px'
    },
    shadow: {
      type: String,
      default: () => '1px 2px 3px rgba(0, 0, 0, 0.16)'
    },
    translate: {
      type: String,
      default: () => '0px'
    },
    deviation: {
      type: String,
      default: () => '15px 15px'
    },
    arrowSize: {
      type: String,
      default: () => '10px 10px'
    },
    cursorSize: {
      type: String,
      default: () => '40px 40px'
    },
    blockStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    menuBlockStyle () {
      let width = this.width || 'auto'
      let style = {
        width: width,
        'white-space': width !== 'auto' ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      }
      return { ...style, ...this.blockStyle }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
.bor-cor.new
  position: relative
  display: flex
  &.no-arrow
    .trigger
      &.display
        &:hover, &.always-display
          & + .menu-container
            &.bottom
              top: calc(100% + var(--dvt-v) - 10px)
            &.top
              bottom: calc(100% + var(--dvt-v) - 10px)
            &.right
              left: calc(100% + var(--dvt-v) - 10px)
            &.left
              right: calc(100% + var(--dvt-v) - 10px)
    .menu-container
      &.bottom
        &:hover
          top: calc(100% + var(--dvt-v) - 10px)
      &.top
        &:hover
          bottom: calc(100% + var(--dvt-v) - 10px)
      &.right
        &:hover
          left: calc(100% + var(--dvt-v) - 10px)
      &.left
        &:hover
          right: calc(100% + var(--dvt-v) - 10px)
  &.is-tooltip
    .trigger
      &.display
        &:hover, &.always-display
          & + .menu-container
            &.bottom
              top: calc(100% - var(--tt-v))
              left: calc(50% - var(--tt-h))
              &.reverse
                left: inherit
                right: calc(50% - var(--tt-h))
            &.top
              bottom: calc(100% - var(--tt-v))
              left: calc(50% - var(--tt-h))
              &.reverse
                left: inherit
                right: calc(50% - var(--tt-h))
            &.right
              left: calc(100% - var(--tt-v))
              bottom: calc(50% - var(--tt-h))
              &.reverse
                bottom: inherit
                top: calc(50% - var(--tt-h))
            &.left
              right: calc(100% - var(--tt-v))
              bottom: calc(50% - var(--tt-h))
              &.reverse
                bottom: inherit
                top: calc(50% - var(--tt-h))
    .menu-container
      &.bottom
        top: calc(100% - var(--tt-v))
        left: calc(50% - var(--tt-h))
        &.reverse
          left: inherit
          right: calc(50% - var(--tt-h))
      &.top
        bottom: calc(100% - var(--tt-v))
        left: calc(50% - var(--tt-h))
        &.reverse
          left: inherit
          right: calc(50% - var(--tt-h))
      &.right
        left: calc(100% - var(--tt-v))
        bottom: calc(50% - var(--tt-h))
        &.reverse
          bottom: inherit
          top: calc(50% - var(--tt-h))
      &.left
        right: calc(100% - var(--tt-v))
        bottom: calc(50% - var(--tt-h))
        &.reverse
          bottom: inherit
          top: calc(50% - var(--tt-h))
  .trigger
    & > div
      display: flex
    &.display
      &:hover, &.always-display
        & + .menu-container
          opacity: 1
          &.bottom
            top: calc(100% + var(--dvt-v))
          &.top
            bottom: calc(100% + var(--dvt-v))
          &.right
            left: calc(100% + var(--dvt-v))
          &.left
            right: calc(100% + var(--dvt-v))
  .menu-container
    position: absolute
    display: flex
    opacity: 0
    transition: opacity .5s ease
    z-index: 10
    filter: drop-shadow(var(--sd-style))
    &:hover
      opacity: 1
    &.bottom
      left: calc(50% - 5px - var(--dvt-h))
      top: -99999px
      &:hover
        top: calc(100% + var(--dvt-v))
      .cursor-bor-cor
        width: var(--cbc-w)
        height: var(--cbc-h)
        top: calc(0px - var(--cbc-h))
        left: calc(var(--dvt-h) - 15px)
      .menu-bor-cor
        top: calc(0px - (var(--arw-h) * 2) + 1px)
        left: calc(var(--dvt-h) + 0px)
        border-width: calc(var(--arw-h) / 1) calc(var(--arw-w) / 2)
        border-color: transparent transparent var(--bg-color)
        &.shadow-top
          top: calc(0px - (var(--arw-h) * 2) - 1px)
          border-color: transparent transparent var(--bd-color)
        &.shadow-left
          left: calc(var(--dvt-h) + 1px)
          border-color: transparent transparent var(--bd-color)
        &.shadow-right
          left: calc(var(--dvt-h) - 1px)
          border-color: transparent transparent var(--bd-color)
      &.reverse
        left: inherit
        right: calc(50% - 5px - var(--dvt-h))
        .cursor-bor-cor
          left: inherit
          right: calc(var(--dvt-h) - 15px)
        .menu-bor-cor
          left: inherit
          right: calc(var(--dvt-h) + 0px)
          &.shadow-top
          &.shadow-left
            left: inherit
            right: calc(var(--dvt-h) + 1px)
          &.shadow-right
            left: inherit
            right: calc(var(--dvt-h) - 1px)
    &.top
      left: calc(50% - 5px - var(--dvt-h))
      bottom: 99999px
      &:hover
        bottom: calc(100% + var(--dvt-v))
      .cursor-bor-cor
        width: var(--cbc-w)
        height: var(--cbc-h)
        bottom: calc(0px - var(--cbc-h))
        left: calc(var(--dvt-h) - 15px)
      .menu-bor-cor
        bottom: calc(0px - (var(--arw-h) * 2) + 1px)
        left: calc(var(--dvt-h) + 0px)
        border-width: calc(var(--arw-h) / 1) calc(var(--arw-w) / 2)
        border-color: var(--bg-color) transparent transparent
        &.shadow-top
          bottom: calc(0px - (var(--arw-h) * 2) - 1px)
          border-color: var(--bd-color) transparent transparent
        &.shadow-left
          left: calc(var(--dvt-h) + 1px)
          border-color: var(--bd-color) transparent transparent
        &.shadow-right
          left: calc(var(--dvt-h) - 1px)
          border-color: var(--bd-color) transparent transparent
      &.reverse
        left: inherit
        right: calc(50% - 5px - var(--dvt-h))
        .cursor-bor-cor
          left: inherit
          right: calc(var(--dvt-h) - 15px)
        .menu-bor-cor
          left: inherit
          right: calc(var(--dvt-h) + 0px)
          &.shadow-top
          &.shadow-left
            left: inherit
            right: calc(var(--dvt-h) + 1px)
          &.shadow-right
            left: inherit
            right: calc(var(--dvt-h) - 1px)
    &.right
      top: calc(50% - 5px - var(--dvt-h))
      left: -99999px
      &:hover
        left: calc(100% + var(--dvt-v))
      .cursor-bor-cor
        width: var(--cbc-h)
        height: var(--cbc-w)
        left: calc(0px - var(--cbc-h))
        top: calc(var(--dvt-h) - 15px)
      .menu-bor-cor
        left: calc(0px - (var(--arw-h) * 2) + 1px)
        top: calc(var(--dvt-h) + 0px)
        border-width: calc(var(--arw-w) / 2) calc(var(--arw-h) / 1)
        border-color: transparent var(--bg-color) transparent transparent
        &.shadow-top
          left: calc(0px - (var(--arw-h) * 2) - 1px)
          border-color: transparent var(--bd-color) transparent transparent
        &.shadow-left
          top: calc(var(--dvt-h) + 1px)
          border-color: transparent var(--bd-color) transparent transparent
        &.shadow-right
          top: calc(var(--dvt-h) - 1px)
          border-color: transparent var(--bd-color) transparent transparent
      &.reverse
        top: inherit
        bottom: calc(50% - 5px - var(--dvt-h))
        .cursor-bor-cor
          top: inherit
          bottom: calc(var(--dvt-h) - 15px)
        .menu-bor-cor
          top: inherit
          bottom: calc(var(--dvt-h) + 0px)
          &.shadow-top
          &.shadow-left
            top: inherit
            bottom: calc(var(--dvt-h) + 1px)
          &.shadow-right
            top: inherit
            bottom: calc(var(--dvt-h) - 1px)
    &.left
      top: calc(50% - 5px - var(--dvt-h))
      right: 99999px
      &:hover
        right: calc(100% + var(--dvt-v))
      .cursor-bor-cor
        width: var(--cbc-h)
        height: var(--cbc-w)
        right: calc(0px - var(--cbc-h))
        top: calc(var(--dvt-h) - 15px)
      .menu-bor-cor
        right: calc(0px - (var(--arw-h) * 2) + 1px)
        top: calc(var(--dvt-h) + 0px)
        border-width: calc(var(--arw-w) / 2) calc(var(--arw-h) / 1)
        border-color: transparent transparent transparent var(--bg-color)
        &.shadow-top
          right: calc(0px - (var(--arw-h) * 2) - 1px)
          border-color: transparent transparent transparent var(--bd-color)
        &.shadow-left
          top: calc(var(--dvt-h) + 1px)
          border-color: transparent transparent transparent var(--bd-color)
        &.shadow-right
          top: calc(var(--dvt-h) - 1px)
          border-color: transparent transparent transparent var(--bd-color)
      &.reverse
        top: inherit
        bottom: calc(50% - 5px - var(--dvt-h))
        .cursor-bor-cor
          top: inherit
          bottom: calc(var(--dvt-h) - 15px)
        .menu-bor-cor
          top: inherit
          bottom: calc(var(--dvt-h) + 0px)
          &.shadow-top
          &.shadow-left
            top: inherit
            bottom: calc(var(--dvt-h) + 1px)
          &.shadow-right
            top: inherit
            bottom: calc(var(--dvt-h) - 1px)
    .cursor-bor-cor
      position: absolute
    .menu-bor-cor
      z-index: 10
      width: 0
      height: 0
      font-size: 0
      border-style: solid
      overflow: hidden
      position: absolute
    .menu-block
      padding: 10px
      color: #777777
      text-align: left
      line-height: 1.4
      background: var(--bg-color)
      box-sizing: border-box
      border-radius: var(--br-value)
      border: 1px solid var(--bd-color)
      word-break: break-word
      white-space: nowrap
      position: relative
      z-index: 10
</style>



// WEBPACK FOOTER //
// src/components/tool/newBorCor.vue